module.exports = __webpack_public_path__ + "static/pic17-2f73969028c8c9f58f1b9e71607621d9.jpg";